import styles from './BackToTopButton.module.scss';
import React from 'react';
import { dispatchGAEvent } from '../../../events/dispatchGAEvent';
import { Ssvg } from '../../../Components/react/Ssvg';
export const BackToTopButton = () => {
    return (React.createElement("div", { className: "text:center" },
        React.createElement("button", { className: `btn:cleared d:inline-flex ai:center ${styles.button}`, onClick: () => {
                dispatchGAEvent('Collection', 'click', 'Back to top');
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, "aria-hidden": true },
            "Back to top ",
            React.createElement(Ssvg, { icon: "icon--arrow-up", className: styles.icon }))));
};
